module.exports = __webpack_public_path__ + "static/s-exam1-d8dab72392e552fcf3a38422ba639afe.png";